import { createContext } from 'react';
import { CurrentUser, CurrentUserTenant } from '@/hooks/use-current-user';

export type AuthStatus = 'loading' | 'authorized' | 'no_organization' | 'unauthorized';

export interface AuthContextValue {
  status: AuthStatus;
  user: CurrentUser | null;
  tenant: CurrentUserTenant | null;
  isAdmin: boolean;
  isSuperAdmin: boolean;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
